import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import TextStyleInputs from './TextStyleInputs';
import ColorPickerInput from './ColorPickerInput';

const NavbarTab = ({ navMenu = {}, updateLocalNavMenuConfig }) => {
    const {
        isFullWidth = false,
        logoUrl = '',
        navElementsStyle = {},
        backgroundColor = '',
        activeElement = {},
    } = navMenu;

    const { hasUnderline = false, colorTheme = 'default', colorOnlyUnderline = false } = activeElement || {};

    return (
        <div>
            {/* Section: Layout */}
            <div className="mb-4">
                <h2 className="h6 text-uppercase text-muted fw-bold border-bottom pb-2 mb-3">Layout & Logo</h2>
                <FormGroup switch className="mb-3">
                    <Input
                        type="switch"
                        id="isNavMenuFullWidth"
                        checked={isFullWidth}
                        onChange={(e) => updateLocalNavMenuConfig({ isFullWidth: e.target.checked })}
                    />
                    <Label check for="isNavMenuFullWidth">
                        Volle Breite für Navigation
                    </Label>
                </FormGroup>

                <FormGroup className="mb-3">
                    <Label for="competitionLogoUrl">Wettbewerbs-Logo-URL</Label>
                    <Input
                        type="text"
                        id="competitionLogoUrl"
                        value={logoUrl || ''}
                        onChange={(e) => updateLocalNavMenuConfig({ logoUrl: e.target.value })}
                        placeholder="z.B. https://example.com/logo.svg"
                    />
                </FormGroup>

                <ColorPickerInput
                    id="navBackgroundColor"
                    label="Hintergrundfarbe"
                    value={backgroundColor}
                    onChange={(color) => updateLocalNavMenuConfig({ backgroundColor: color })}
                    placeholder="z.B. #ffffff oder transparent"
                />
            </div>

            {/* Section: Navigation Style */}
            <div className="mb-4">
                <h2 className="h6 text-uppercase text-muted fw-bold border-bottom pb-2 mb-3">
                    Navigation-Schriftgestaltung
                </h2>
                <TextStyleInputs
                    label="Navigation-Elemente Textstil"
                    styleConfig={navElementsStyle}
                    onChange={(style) => updateLocalNavMenuConfig({ navElementsStyle: style })}
                />
            </div>

            {/* Section: Active Element */}
            <div className="mb-4">
                <h2 className="h6 text-uppercase text-muted fw-bold border-bottom pb-2 mb-3">
                    Aktiver Navigationspunkt
                </h2>
                <FormGroup switch className="mb-3">
                    <Input
                        type="switch"
                        id="hasActiveUnderline"
                        checked={hasUnderline}
                        onChange={(e) =>
                            updateLocalNavMenuConfig({
                                activeElement: {
                                    ...(activeElement || {}),
                                    hasUnderline: e.target.checked,
                                },
                            })
                        }
                    />
                    <Label check for="hasActiveUnderline">
                        Unterstreichung für aktives Element aktivieren
                    </Label>
                </FormGroup>

                {hasUnderline && (
                    <FormGroup switch className="mb-3">
                        <Input
                            type="switch"
                            id="activeColorOnlyUnderline"
                            checked={colorOnlyUnderline}
                            onChange={(e) =>
                                updateLocalNavMenuConfig({
                                    activeElement: {
                                        ...(activeElement || {}),
                                        colorOnlyUnderline: e.target.checked,
                                    },
                                })
                            }
                        />
                        <Label check for="activeColorOnlyUnderline">
                            Aktiv-Farbe nur auf Unterstreichung anwenden (Textfarbe bleibt Standard)
                        </Label>
                    </FormGroup>
                )}

                <FormGroup className="mb-3">
                    <Label for="activeColorTheme">Aktiv-Farbe</Label>
                    <Input
                        type="select"
                        id="activeColorTheme"
                        value={colorTheme}
                        onChange={(e) =>
                            updateLocalNavMenuConfig({
                                activeElement: {
                                    ...(activeElement || {}),
                                    colorTheme: e.target.value,
                                },
                            })
                        }
                    >
                        <option value="default">Standard</option>
                        <option value="primary">Primär (Primary)</option>
                        <option value="secondary">Sekundär (Secondary)</option>
                    </Input>
                </FormGroup>
            </div>
        </div>
    );
};

export default NavbarTab;
